import { DataButton, H5, H6 } from "@sellar-io/components";
import { useFavouriteNotificationPreferenceList } from "../../hooks/api/v2/favouriteNotificationPreference/useFavouriteNotificationPreferenceList";
import { useBuyerRelationshipFavouriteCreate } from "../../hooks/api/v2/buyerRelationshipFavourite/useBuyerRelationshipFavouriteCreate";
import { Icon } from "../index";
import { TooltipContent } from "@sellar-io/components";
import { TooltipTrigger } from "@sellar-io/components";
import { Tooltip } from "@sellar-io/components";

export const AddToFavouritesButton = ({
  buyerRelationshipId,
  setAddedToFavourites,
  setDialogActive,
}: {
  buyerRelationshipId: number;
  setAddedToFavourites: (addedToFavourites: boolean) => void;
  setDialogActive: (active: boolean) => void;
}) => {
  const favouriteNotificationPreferenceListQuery =
    useFavouriteNotificationPreferenceList({
      limit: 1,
    });

  const isFirstFavourite =
    !favouriteNotificationPreferenceListQuery.isPending &&
    favouriteNotificationPreferenceListQuery.data?.pages[0]?.length === 0;
  const addToFavouritesMutation = useBuyerRelationshipFavouriteCreate();
  const addToFavourites = () => {
    return addToFavouritesMutation.mutate(
      {
        buyerRelationshipId,
      },
      {
        onSuccess: () => {
          if (isFirstFavourite) {
            setDialogActive(true);
          }
          setAddedToFavourites(true);
        },
      },
    );
  };
  return (
    <>
      <Tooltip placement="bottom">
        <TooltipTrigger className="w-fit">
          <DataButton
            active={false}
            className={"w-fit"}
            onClick={() => addToFavourites()}
            border={true}
            loading={addToFavouritesMutation.isPending}
          >
            <Icon icon={"HEART_OUTLINE"} className={"text-purple-800"} />
            Add to favourites
          </DataButton>
        </TooltipTrigger>
        <TooltipContent
          className={
            "Tooltip w-[350px] rounded-lg border border-zinc-300 bg-white px-4 py-3 shadow-lg"
          }
        >
          <div className="absolute top-[-7px] left-1/2 -translate-x-1/2">
            <div className="h-3 w-3 rotate-45 transform border-t border-l border-gray-300 bg-white"></div>
          </div>
          <div className="flex flex-row items-center gap-2">
            <Icon icon={"INFORMATION_OUTLINE"} className={"flex-none"} />
            <div className="flex flex-col">
              <H5>Never miss a product release</H5>
              <H6 className={"text-sm"}>
                Get notification on new releases without having to check
                yourself
              </H6>
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </>
  );
};
